import { Component } from '@angular/core';
import { AlertController, App } from 'ionic-angular';
import { WalletPage } from '../wallet/wallet';
import { MypagePage } from '../mypage/mypage';
// import { WithdrawalcoinlistPage } from '../withdrawalcoinlist/withdrawalcoinlist';
import { ApplylistPage } from '../applylist/applylist';
import { WithdrawalPage } from '../withdrawal/withdrawal';
// import { HomePage } from '../home/home';

@Component({
  	templateUrl: 'tabs.html'
})
export class TabsPage {

	tab1Root = WalletPage;  
	tab2Root = ApplylistPage;
	tab3Root = WithdrawalPage
	// tab4Root = AvatalistPage;
	tab4Root = MypagePage;
	// tab5Root = HomePage;

	texts: any = [];
    language: string;

	constructor(		
		public alertCtrl: AlertController,
		public app: App
	) {
		
	}

	ionViewWillEnter() {	
		this.language = localStorage.getItem("language");

		this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).tabs;
	}

	_back() {
		let alert = this.alertCtrl.create({
			message: this.texts.alertM_ready,
			buttons: ['OK']
		});
		alert.present();
	}
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts